module.exports = __webpack_public_path__ + "media/images/vod_icons/yogasix-13022a95e200fc80d6b3fdef43bd2ea5.svg";